import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { ItinerariesService, ProfileService } from 'core/services';
import { PreloaderPosition, Profile } from 'core/models';
import { ItinerariesQuestionsService } from '../../itineraries/services/itineraries-questions.service';

export const ItineraryResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  itinerariesService: ItinerariesService = inject(ItinerariesService),
  profileService: ProfileService = inject(ProfileService),
  itinerariesQuestionService: ItinerariesQuestionsService = inject(ItinerariesQuestionsService)
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const loggedUser: Profile = profileService.getLoggedUser();

    const itinerary = route.paramMap.get('itineraryId');
    const clientId =
      route.paramMap.get('clientId') || route.queryParamMap.get('clientId') || profileService.getFixedClientId();

    if (itinerary) {
      itinerariesService
        .getItinerary(itinerary, clientId, loggedUser.lang)
        .then((itinerary: any) => {
          route.routeConfig.data = {
            ...route.data,
            preloader: itinerariesQuestionService.canUserEditItinerary(itinerary, clientId)
              ? PreloaderPosition.Secondary
              : PreloaderPosition.Primary
          };
          resolve(itinerary);
        })
        .catch((err) => reject(err));
    } else {
      return resolve(null);
    }
  });
};
